/* eslint-disable @next/next/no-html-link-for-pages */
import classNames from 'classnames';

import classes from './PageHeaderBreadcrumb.module.less';

import ImageC from '@/components/Image';
import { PageHeaderBreadcrumpProps } from '@/interface';

const PageHeaderBreadcrumb = (props: PageHeaderBreadcrumpProps) => {
	const { breadcrumbs, withTitle } = props;

	if (!breadcrumbs || breadcrumbs?.length <= 0) return null;

	return (
		<div
			className={classNames(classes.breadcrumb, {
				[classes['breadcrumb-with-title']]: withTitle,
				['container']: !withTitle,
				[classes['breadcrumb-without-title']]: !withTitle,
			})}
		>
			<span>
				<a href="/" className={classes.link}>
					Home
				</a>
				<span className="mx-2">
					<ImageC src="/images/header/arrow-chevron-right-gray.svg" width={10} height={10} />
				</span>
			</span>
			{breadcrumbs?.map((i, idx) => (
				<span key={i.label} className={classes.text}>
					{i.navigatePath ? (
						<a href={i.navigatePath} className={classes.link}>
							{i.label}
						</a>
					) : (
						i.label
					)}
					{idx < breadcrumbs?.length - 1 ? (
						<span className="mx-2">
							<ImageC src="/images/header/arrow-chevron-right-gray.svg" width={10} height={10} />
						</span>
					) : null}
				</span>
			))}
		</div>
	);
};

export default PageHeaderBreadcrumb;
